module.exports = __webpack_public_path__ + "static/media/Krombacher-SansDemi.2910612e.otf";